import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter } from 'react-modal-bootstrap';
import './GeneralModal.scss';

class GeneralModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: this.props.show,
    };
  }

  handleCTA = () => {
    this.setState({ showModal: false });
  }

  render() {
    return (
      <Modal
        className="topLevelontainer"
        isOpen={this.state.showModal}
        onRequestHide={() => this.setState({ showModal: false })}
      >
        <ModalBody>
          <div>{this.props.bodyText}</div>
        </ModalBody>
        <ModalFooter className="footer">
          <button
            className="btn greenBtn"
            onClick={this.handleCTA}
          >
            Ok
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

GeneralModal.propTypes = {
  bodyText: PropTypes.string.isRequired,
  show: PropTypes.bool.isRequired,
};

export default GeneralModal;
